import {
  CREATE_NEW_CAMPAIGN,
  DELETE_ADGROUP,
  DELETE_CAMPAIGN,
  DELETE_CAMPAIGN_AD,
  DELETE_MULTIPLE_CAMPAIGN,
  DUPLICATE_ADGROUP,
  DUPLICATE_CAMPAIGN,
  GET_ACCOUNT_CAMPAIGNS,
  GET_ACTIVE_CAMPAIGNS_FOR_SOURCES,
  GET_CALL_CAMPAIGN_STATS,
  GET_CALL_CAMPAIGN_STATS_BY_ID,
  GET_CAMPAIGNS,
  GET_CAMPAIGNS_SOURCE_SETTINGS,
  GET_BID_MULTIPLIER_HISTORY,
  GET_CAMPAIGN_BY_ID,
  GET_CLICK_CAMPAIGN_STATS,
  GET_CLICK_CAMPAIGN_STATS_BY_ID,
  GET_FILTER_PACKAGES,
  GET_FILTER_VOLUME,
  GET_LEAD_CAMPAIGN_STATS,
  GET_LEAD_CAMPAIGN_STATS_BY_ID,
  MODIFY_ADGROUP,
  MODIFY_CAMPAIGN,
  MODIFY_CAMPAIGN_AD,
  NEW_ADGROUP,
  NEW_ADGROUP_TRACKING,
  NEW_CAMPAIGN_AD,
  GET_DEFAULT_TRANSFER_NUMBER,
  GET_AD_GROUP_STATS_V4,
  GET_AD_GROUP_BID_MULTIPLIER_HISTORY,
} from "./actionTypes"
import { call, put, takeEvery, takeLatest } from "redux-saga/effects"
import {
  deleteCampaignAdError,
  deleteCampaignAdSuccess,
  deleteCampaignError,
  deleteCampaignSuccess,
  duplicateAdgroupError,
  duplicateAdgroupSuccess,
  duplicateCampaignError,
  duplicateCampaignSuccess,
  getCampaignByIdError,
  getCampaignByIdSuccess,
  getCampaignError,
  getCampaignSuccess,
  modifyAdgroupError,
  modifyAdgroupSuccess,
  modifyCampaignError,
  modifyCampaignSuccess,
  newAdgroupError,
  newAdgroupSuccess,
  newAdgroupTrackingError,
  newCampaignAdError,
  newCampaignAdSuccess,
  newCampaignError,
  newCampaignSuccess,
  newAdgroupTrackingSuccess,
  modifyCampaignAdSuccess,
  modifyCampaignAdError,
  deleteAdgroupSuccess,
  deleteAdgroupError,
  deleteMultipleCampaignSuccess,
  deleteMultipleCampaignError,
  getAccountCampaignSuccess,
  getAccountCampaignError,
  getFilterVolumeSuccess,
  getFilterVolumeError,
  getClickCampaignStatsSuccess,
  getClickCampaignStatsError,
  getClickCampaignStatsByIdSuccess,
  getClickCampaignStatsByIdError,
  getLeadCampaignStatsError,
  getLeadCampaignStatsByIdSuccess,
  getLeadCampaignStatsByIdError,
  getCallCampaignStatsSuccess,
  getCallCampaignStatsError,
  getCallCampaignStatsByIdSuccess,
  getCallCampaignStatsByIdError,
  getLeadCampaignStatsSuccess,
  getFilterPackagesSuccess,
  getFilterPackagesError,
  getCampaignSourceSettingSuccess,
  getCampaignSourceSettingError,
  getBidMultiplierHistorySuccess,
  getBidMultiplierHistoryError,
  getActiveCampaignsForSourcesError,
  getActiveCampaignsForSourcesSuccess,
  getDefaultTransferNumberSuccess,
  getDefaultTransferNumberError,
  getAdGroupStatsV4Success,
  getAdGroupStatsV4Error,
  getAdGroupBidMultiplierHistorySuccess,
  getAdGroupBidMultiplierHistoryError,
} from "./actions"
import {
  deleteCampaign_Ad,
  deleteCampaign_api,
  postCreateAdgroup,
  postCreateCampaign,
  postDuplicateCampaign,
  putModifyAdgroup,
  putModifyCampaign,
  postCreateAdgrouptracking,
  genericPutRequest,
  deleteAdgroup_api,
  genericGetRequest,
  genericGetRequest_2,
  genericPostRequest
} from "../../helpers/sf_backend_helper";

import { AppConfiguration } from "config";
import { campaign_modify_section_check } from "helpers/sf_campaign_modify_section_check";
import { getCurrentBrandFromLocalStorage } from "helpers/sf_utils";

const getRtbBrandId = (rtbBrandPayload) => {
  if (!rtbBrandPayload?.show_rtb_brand_ui_changes) {
    return null
  }

  const brandId = rtbBrandPayload?.brand_id
  return typeof brandId === "string" ? JSON.parse(brandId) : brandId
}

const getCreateCampaignRequest = (campaign) => {
  const {
    use_single_request_campaign_create,
    rtbBrandPayload,
    ...singleRequestCampaign
  } = campaign

  if (use_single_request_campaign_create) {
    return {
      campaign: singleRequestCampaign,
      brand_id: getRtbBrandId(rtbBrandPayload),
      show_rtb_brand_ui_changes: rtbBrandPayload?.show_rtb_brand_ui_changes,
    }
  }

  return {
    campaign: {
      name: campaign.name,
      lead_type: campaign.lead_type,
      product_type: campaign.product_type,
      shared_lead_type: campaign.shared_lead_type,
      inbound_only: campaign?.inbound_only || false,
    },
    brand_id: getRtbBrandId(campaign?.rtbBrandPayload),
    show_rtb_brand_ui_changes: campaign?.rtbBrandPayload?.show_rtb_brand_ui_changes,
  }
}

// Login Redux States
function* createCampaign({ payload: { campaign, history } }) {
  try {
    if (AppConfiguration.DEFAULT_AUTH === "jwt") {
      let user_auth = localStorage.getItem("authUser")
      const createCampaignRequest = getCreateCampaignRequest(campaign)
      const response = yield call(
        postCreateCampaign,
        `${AppConfiguration.BACKEND_URL}/api/v1/campaigns`,
        {
          campaign: createCampaignRequest.campaign,
          token: JSON.parse(user_auth).user.token,
          account_id: JSON.parse(user_auth).user.account_id,
          brand_id: createCampaignRequest.brand_id,
          show_rtb_brand_ui_changes: createCampaignRequest.show_rtb_brand_ui_changes
        }
      )
      yield put(newCampaignSuccess(response))
    } else if (AppConfiguration.DEFAULT_AUTH === "fake") {
    }
    // history.push("/campaigns")
  } catch (error) {
    yield put(newCampaignError(error))
  }
}

function* onDuplicateCampaign({ payload: campaign }) {
  try {
    if (AppConfiguration.DEFAULT_AUTH === "jwt") {
      let user_auth = localStorage.getItem("authUser")
      const response = yield call(
        postDuplicateCampaign,
        `${AppConfiguration.BACKEND_URL}/api/v1/duplicate_campaigns`,
        {
          campaign,
          token: JSON.parse(user_auth).user.token,
          account_id: JSON.parse(user_auth).user.account_id,
        }
      )
      yield put(duplicateCampaignSuccess(response))
    }
  } catch (error) {
    yield put(duplicateCampaignError(error))
  }
}

// Fetch All Campaign
function* fetchCampaigns(action) {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    const response = yield call(
      genericGetRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/campaigns`,
      action.payload.queryParams,
      {
        Authorization: user.token,
        'account-id': user.account_id,
        'brand-id': getCurrentBrandFromLocalStorage()?.id
      }
    )
    yield put(getCampaignSuccess(response, action.payload?.time_frame_key))
  } catch (error) {
    // pass along what this request asked for, so callers can tell whether the failure was theirs
    const requested_range = action.payload?.fetched_range || action.payload?.queryParams || {}
    yield put(getCampaignError(error, {
      time_frame_key: action.payload?.time_frame_key ?? null,
      start_date: requested_range?.start_date ?? null,
      end_date: requested_range?.end_date ?? null,
    }))
  }
}

// Fetch All Campaign By Id
function* fetchCampaignsById(action) {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    const response = yield call(
      genericGetRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/campaigns/${action.payload.id}`,
      action.payload.queryParams,
      {
        Authorization: user.token,
        'account-id': user.account_id
      }
    )
    yield put(getCampaignByIdSuccess(response, action.payload?.time_frame_key, action.payload?.queryParams, action.payload?.feature_flag))
  } catch (error) {
    yield put(getCampaignByIdError(error))
  }
}

// Modify Campaign By Id
function* modifyCampaign(campaign) {
  const campaignSectionName = campaign.payload.section_name;
  const campaignData = campaign_modify_section_check(campaignSectionName, campaign);
  try {
    if (AppConfiguration.DEFAULT_AUTH === "jwt") {
      let user_auth = localStorage.getItem("authUser")
      const response = yield call(
        putModifyCampaign,
        `${AppConfiguration.BACKEND_URL}/api/v1/campaigns/${campaign.payload.lastId}`,
        {
          campaign: campaignData,
          token: JSON.parse(user_auth).user.token,
          account_id: JSON.parse(user_auth).user.account_id,
        }
      )
      yield put(modifyCampaignSuccess(response))
    } else if (AppConfiguration.DEFAULT_AUTH === "fake") {
    }
  } catch (error) {
    yield put(modifyCampaignError(error))
  }
}



// Create Adgroup
function* newAdgroup(adgroup) {
  try {
    if (AppConfiguration.DEFAULT_AUTH === "jwt") {
      let user_auth = localStorage.getItem("authUser")
      const response = yield call(
        postCreateAdgroup,
        `${AppConfiguration.BACKEND_URL}/api/v1/ad_groups`,
        {
          adgroup: adgroup.payload,
          token: JSON.parse(user_auth).user.token,
          account_id: JSON.parse(user_auth).user.account_id,
        }
      )
      yield put(newAdgroupSuccess(response))
    } else if (AppConfiguration.DEFAULT_AUTH === "fake") {
    }
  } catch (error) {
    yield put(newAdgroupError(error))
  }
}

function* createDuplicateAdgroup(adgroup) {
  try {
    if (AppConfiguration.DEFAULT_AUTH === "jwt") {
      let user_auth = localStorage.getItem("authUser")
      const response = yield call(
        postCreateAdgroup,
        `${AppConfiguration.BACKEND_URL}/api/v1/duplicate_ad_groups`,
        {
          adgroup: adgroup.payload,
          token: JSON.parse(user_auth).user.token,
          account_id: JSON.parse(user_auth).user.account_id,
        }
      )
      yield put(duplicateAdgroupSuccess(response))
    } else if (AppConfiguration.DEFAULT_AUTH === "fake") {
    }
  } catch (error) {
    yield put(duplicateAdgroupError(error))
  }
}

// Modify Adgroup
function* modifyAdgroup(adgroup) {
  try {
    let user_auth = localStorage.getItem("authUser")
    const response = yield call(
      putModifyAdgroup,
      `${AppConfiguration.BACKEND_URL}/api/v1/ad_groups/${adgroup.payload.id}`,
      {
        adgroup: adgroup.payload,
        token: JSON.parse(user_auth).user.token,
        account_id: JSON.parse(user_auth).user.account_id,
      }
    )
    yield put(modifyAdgroupSuccess({ adgroup: response?.data, additional_data: response?.additional_data }))
  } catch (error) {
    yield put(modifyAdgroupError(error))
  }
}

// Delete Campaign
function* deleteCampaign(campaign) {
  try {
    let user_auth = localStorage.getItem("authUser")
    const response = yield call(
      deleteCampaign_api,
      `${AppConfiguration.BACKEND_URL}/api/v1/campaigns/${campaign.payload.id}`,
      {
        token: JSON.parse(user_auth).user.token,
        account_id: JSON.parse(user_auth).user.account_id,
      }
    )
    yield put(deleteCampaignSuccess(response))
  } catch (error) {
    yield put(deleteCampaignError(error))
  }
}

//Delete multiple campaigns
function* deleteMultipleCampaign(campaign_ids) {
  try {
    let user_auth = localStorage.getItem("authUser")
    const response = yield call(
      deleteCampaign_api,
      `${AppConfiguration.BACKEND_URL}/api/v1/campaigns/${campaign_ids.payload.join(',')}`,
      {
        token: JSON.parse(user_auth).user.token,
        account_id: JSON.parse(user_auth).user.account_id,
      }
    )
    yield put(deleteMultipleCampaignSuccess(response))
  } catch (error) {
    yield put(deleteMultipleCampaignError(error))
  }
}

// Create Campaign Ad

function* newCampaignAd(campaign_ad) {
  try {
    if (AppConfiguration.DEFAULT_AUTH === "jwt") {
      let user_auth = localStorage.getItem("authUser")
      const response = yield call(
        postCreateAdgroup,
        `${AppConfiguration.BACKEND_URL}/api/v1/campaign_ads`,
        {
          adgroup: campaign_ad.payload,
          token: JSON.parse(user_auth).user.token,
          account_id: JSON.parse(user_auth).user.account_id,
        }
      )
      yield put(newCampaignAdSuccess(response))
    } else if (AppConfiguration.DEFAULT_AUTH === "fake") {
    }
  } catch (error) {
    yield put(newCampaignAdError(error))
  }
}

// Delete Campaign Ad
function* deleteCampaignAd(campaign_ad) {
  try {
    let user_auth = localStorage.getItem("authUser")
    const response = yield call(
      deleteCampaign_Ad,
      `${AppConfiguration.BACKEND_URL}/api/v1/campaign_ads/${campaign_ad.payload.id}`,
      {
        campaign_ad: campaign_ad,
        token: JSON.parse(user_auth).user.token,
        account_id: JSON.parse(user_auth).user.account_id,
      }
    )
    yield put(deleteCampaignAdSuccess(response))
  } catch (error) {
    yield put(deleteCampaignAdError(error))
  }
}

function* onNewAdgroupTracking(adgrp) {
  try {
    if (AppConfiguration.DEFAULT_AUTH === "jwt") {
      let user_auth = localStorage.getItem("authUser")
      const response = yield call(
        postCreateAdgrouptracking,
        `${AppConfiguration.BACKEND_URL}/api/v1/adgroup_trackings`,
        {
          adgroup: adgrp.payload,
          token: JSON.parse(user_auth).user.token,
          account_id: JSON.parse(user_auth).user.account_id,
        }
      )
      yield put(newAdgroupTrackingSuccess(response))
    } else if (AppConfiguration.DEFAULT_AUTH === "fake") {
    }
  } catch (error) {
    yield put(newAdgroupTrackingError(error))
  }
}

function* onModifyCampaignAd(action) {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    const response = yield call(
      genericPutRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/campaign_ads/${action.payload.id}`,
      {
        body: JSON.stringify({
          ...action.payload
        }),
        headers: {
          Authorization: user.token,
          'account-id': user.account_id,
          'Content-Type': 'application/json'
        }
      }
    )
    yield put(modifyCampaignAdSuccess(response))
  } catch (error) {
    yield put(modifyCampaignAdError(error))
  }
}

function* onDeleteAdgroup(adgroup) {
  try {
    if (AppConfiguration.DEFAULT_AUTH === "jwt") {
      let user_auth = localStorage.getItem("authUser")
      const response = yield call(
        deleteAdgroup_api,
        `${AppConfiguration.BACKEND_URL}/api/v1/ad_groups/${adgroup.payload.id}`,
        {
          adgroup: adgroup.payload,
          token: JSON.parse(user_auth).user.token,
          account_id: JSON.parse(user_auth).user.account_id,
        }
      )
      yield put(deleteAdgroupSuccess(response))
    }
  } catch (error) {
    yield put(deleteAdgroupError(error))
  }
}

// Fetch All Account Campaign
function* OnGetAccountCampaigns() {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    const response = yield call(
      genericGetRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/account_campaigns`,
      {},
      {
        Authorization: user.token,
        'account-id': user.account_id,
      }
    )
    yield put(getAccountCampaignSuccess(response))
  } catch (error) {
    yield put(getAccountCampaignError(error))
  }
}

// Fetch All filter Volume
function* fetchFilterVolume(action) {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    const response = yield call(
      genericPostRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/campaign_filter_volume`,
      {
        body: JSON.stringify({
          ...action.payload
        }),
        headers: {
          Authorization: user.token,
          'account-id': user.account_id,
          'Content-Type': 'application/json',
        },
      }
    )
    yield put(getFilterVolumeSuccess(response))
  } catch (error) {
    yield put(getFilterVolumeError(error))
  }
}

function* onGetClickCampaignStats(action) {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    let endpoint = '/api/v1/click_campaign_stats'
    if (action.payload?.use_new_campaign_stats) {
      endpoint = '/api/v2/click_campaign_stats'
    } else if (action.payload?.use_v3_api_for_campaign_stats) {
      endpoint = '/api/v3/click_campaign_stats'
    }
    const response = yield call(
      genericGetRequest,
      `${AppConfiguration.BACKEND_URL}${endpoint}`,
      action.payload.queryParams,
      {
        Authorization: user.token,
        'account-id': user.account_id,
        'brand-id': getCurrentBrandFromLocalStorage()?.id
      }
    )
    yield put(getClickCampaignStatsSuccess(response, action.payload?.time_frame_key))
  } catch (error) {
    yield put(getClickCampaignStatsError(error))
  }
}

function* onGetClickCampaignStatsById(action) {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    let endpoint = '/api/v1/click_campaign_stats'
    if (action.payload?.use_new_campaign_stats) {
      endpoint = '/api/v2/click_campaign_stats'
    } else if (action.payload?.use_v3_api_for_campaign_stats) {
      endpoint = '/api/v3/click_campaign_stats'
    }
    const response = yield call(
      genericGetRequest,
      `${AppConfiguration.BACKEND_URL}${endpoint}/${action.payload.id}`,
      action.payload.queryParams,
      {
        Authorization: user.token,
        'account-id': user.account_id
      }
    )
    yield put(getClickCampaignStatsByIdSuccess(response, action.payload?.time_frame_key, action.payload?.queryParams, action.payload?.feature_flag))
  } catch (error) {
    yield put(getClickCampaignStatsByIdError(error))
  }
}

function* onGetLeadCampaignStats(action) {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    let endpoint = '/api/v1/lead_campaign_stats'
    if (action.payload?.use_new_campaign_stats) {
      endpoint = '/api/v2/lead_campaign_stats'
    }
    const response = yield call(
      genericGetRequest,
      `${AppConfiguration.BACKEND_URL}${endpoint}`,
      action.payload.queryParams,
      {
        Authorization: user.token,
        'account-id': user.account_id,
        'brand-id': getCurrentBrandFromLocalStorage()?.id
      }
    )
    yield put(getLeadCampaignStatsSuccess(response, action.payload?.time_frame_key))
  } catch (error) {
    yield put(getLeadCampaignStatsError(error))
  }
}

function* onGetLeadCampaignStatsById(action) {
  try {

    let user = JSON.parse(localStorage.getItem("authUser")).user
    let endpoint = '/api/v1/lead_campaign_stats'
    if (action.payload?.use_new_campaign_stats) {
      endpoint = '/api/v2/lead_campaign_stats'
    }
    const response = yield call(
      genericGetRequest,
      `${AppConfiguration.BACKEND_URL}${endpoint}/${action.payload.id}`,
      action.payload.queryParams,
      {
        Authorization: user.token,
        'account-id': user.account_id
      }
    )
    yield put(getLeadCampaignStatsByIdSuccess(response, action.payload?.time_frame_key, action.payload?.queryParams, action.payload?.feature_flag))
  } catch (error) {

    yield put(getLeadCampaignStatsByIdError(error))
  }
}

function* onGetCallCampaignStats(action) {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    let endpoint = '/api/v1/call_campaign_stats'
    if (action.payload?.use_new_campaign_stats) {
      endpoint = '/api/v2/call_campaign_stats'
    }
    const response = yield call(
      genericGetRequest,
      `${AppConfiguration.BACKEND_URL}${endpoint}`,
      action.payload.queryParams,
      {
        Authorization: user.token,
        'account-id': user.account_id,
        'brand-id': getCurrentBrandFromLocalStorage()?.id
      }
    )
    yield put(getCallCampaignStatsSuccess(response, action.payload?.time_frame_key))
  } catch (error) {
    yield put(getCallCampaignStatsError(error))
  }
}

function* onGetCallCampaignStatsById(action) {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    let endpoint = '/api/v1/call_campaign_stats'
    if (action.payload?.use_new_campaign_stats) {
      endpoint = '/api/v2/call_campaign_stats'
    }
    const response = yield call(
      genericGetRequest,
      `${AppConfiguration.BACKEND_URL}${endpoint}/${action.payload.id}`,
      action.payload.queryParams,
      {
        Authorization: user.token,
        'account-id': user.account_id
      }
    )
    yield put(getCallCampaignStatsByIdSuccess(response, action.payload?.time_frame_key, action.payload?.queryParams, action.payload?.feature_flag))
  } catch (error) {
    yield put(getCallCampaignStatsByIdError(error))
  }
}

function* onGetFilterPackages(action) {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    const response = yield call(
      genericGetRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/filter_packages`,
      action.payload,
      {
        Authorization: user.token,
        'account-id': user.account_id
      }
    )
    yield put(getFilterPackagesSuccess(response))
  } catch (error) {
    yield put(getFilterPackagesError(error))
  }
}

function* OnGetSourceSettings(action) {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    const response = yield call(
      genericGetRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/campaign_source_settings/${action.payload.campaign_id}`,
      { filters: JSON.stringify(action.payload.data || {}) },
      {
        Authorization: user.token,
        'account-id': user.account_id
      }
    )
    yield put(getCampaignSourceSettingSuccess(response, action.payload.campaign_id))
  } catch (error) {
    yield put(getCampaignSourceSettingError(error))
  }
}

function* OnGetBidMultiplierHistory(action) {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    const response = yield call(
      genericGetRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/campaign_source_settings/${action.payload.campaign_source_setting_id}/bid_multiplier_history`,
      {},
      {
        Authorization: user.token,
        'account-id': user.account_id
      }
    )
    yield put(getBidMultiplierHistorySuccess(response?.bid_multiplier_history || []))
  } catch (error) {
    yield put(getBidMultiplierHistoryError(error))
  }
}

function* onGetAdGroupBidMultiplierHistory(action) {
  try {
    const user = JSON.parse(localStorage.getItem("authUser")).user
    const response = yield call(
      genericGetRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/ad_groups/${action.payload.ad_group_id}/bid_multiplier_history`,
      {},
      {
        Authorization: user.token,
        "account-id": user.account_id,
      }
    )

    yield put(
      getAdGroupBidMultiplierHistorySuccess(
        response?.bid_multiplier_history || []
      )
    )
  } catch (error) {
    yield put(getAdGroupBidMultiplierHistoryError(error))
  }
}

function* OnGetActiveCampaignForSources(action) {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    const response = yield call(
      genericGetRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/active_campaigns_for_sources/${action?.payload?.campaign_id}`,
      action.payload,
      {
        Authorization: user.token,
        'account-id': user.account_id,
        'brand-id': getCurrentBrandFromLocalStorage()?.id
      }
    )
    yield put(getActiveCampaignsForSourcesSuccess(response))
  } catch (error) {
    yield put(getActiveCampaignsForSourcesError(error))
  }
}

function* getDefaultTransferNumberSaga(action) {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user;
    const response = yield call(
      genericGetRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/account_default_transfer_number`,
      { lead_type_id: action.payload.lead_type_id },
      {
        'Authorization': user.token,
        'account-id': user.account_id
      }
    );

    yield put(getDefaultTransferNumberSuccess(response));

  } catch (error) {
    yield put(getDefaultTransferNumberError(error));
  }
}

function* onGetAdGroupStatsV4(action) {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user;
    const { campaign_id, start_date, end_date } = action.payload;
    const response = yield call(
      genericGetRequest_2,
      `${AppConfiguration.BACKEND_URL}/api/v4/campaigns/${campaign_id}/ad_group_stats/quote_funnels`,
      { start_date, end_date },
      {
        'Authorization': user.token,
        'account-id': user.account_id,
        'brand-id': getCurrentBrandFromLocalStorage()?.id
      }
    );

    yield put(getAdGroupStatsV4Success(response.data));

  } catch (error) {
    yield put(getAdGroupStatsV4Error(error));
  }
}

function* campaignSaga() {
  yield takeEvery(CREATE_NEW_CAMPAIGN, createCampaign);
  yield takeEvery(DUPLICATE_CAMPAIGN, onDuplicateCampaign);
  yield takeLatest(GET_CAMPAIGNS, fetchCampaigns);
  yield takeLatest(GET_CAMPAIGN_BY_ID, fetchCampaignsById);
  yield takeEvery(MODIFY_CAMPAIGN, modifyCampaign);
  yield takeEvery(NEW_ADGROUP, newAdgroup);
  yield takeEvery(NEW_CAMPAIGN_AD, newCampaignAd);
  yield takeEvery(MODIFY_ADGROUP, modifyAdgroup);
  yield takeEvery(DUPLICATE_ADGROUP, createDuplicateAdgroup);
  yield takeEvery(DELETE_CAMPAIGN, deleteCampaign);
  yield takeEvery(DELETE_CAMPAIGN_AD, deleteCampaignAd);
  yield takeEvery(MODIFY_CAMPAIGN_AD, onModifyCampaignAd)
  yield takeEvery(NEW_ADGROUP_TRACKING, onNewAdgroupTracking);
  yield takeEvery(DELETE_ADGROUP, onDeleteAdgroup);
  yield takeEvery(DELETE_MULTIPLE_CAMPAIGN, deleteMultipleCampaign);
  yield takeEvery(GET_ACCOUNT_CAMPAIGNS, OnGetAccountCampaigns);
  yield takeEvery(GET_FILTER_VOLUME, fetchFilterVolume);
  yield takeLatest(GET_CLICK_CAMPAIGN_STATS, onGetClickCampaignStats);
  yield takeLatest(GET_CLICK_CAMPAIGN_STATS_BY_ID, onGetClickCampaignStatsById);
  yield takeLatest(GET_LEAD_CAMPAIGN_STATS, onGetLeadCampaignStats);
  yield takeLatest(GET_LEAD_CAMPAIGN_STATS_BY_ID, onGetLeadCampaignStatsById);
  yield takeLatest(GET_CALL_CAMPAIGN_STATS, onGetCallCampaignStats);
  yield takeLatest(GET_CALL_CAMPAIGN_STATS_BY_ID, onGetCallCampaignStatsById);
  yield takeEvery(GET_FILTER_PACKAGES, onGetFilterPackages);
  yield takeLatest(GET_CAMPAIGNS_SOURCE_SETTINGS, OnGetSourceSettings);
  yield takeLatest(GET_BID_MULTIPLIER_HISTORY, OnGetBidMultiplierHistory);
  yield takeLatest(GET_ACTIVE_CAMPAIGNS_FOR_SOURCES, OnGetActiveCampaignForSources);
  yield takeLatest(GET_DEFAULT_TRANSFER_NUMBER, getDefaultTransferNumberSaga);
  yield takeLatest(GET_AD_GROUP_STATS_V4, onGetAdGroupStatsV4);
  yield takeLatest(GET_AD_GROUP_BID_MULTIPLIER_HISTORY, onGetAdGroupBidMultiplierHistory);
}


export default campaignSaga;
